import React from 'react'
import Logo from './Logo'
import TitleBarButton from './TitleBarButton'
import Logout from './Logout'
import DateTime from './DateTime'
import { connect } from 'react-redux';
import * as general from '../constants/General'
import * as resource from '../constants/Resources'
import { getTranslation } from '../actions/dataActions'
import PropTypes from 'prop-types'

class TitleBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { warningActive: false };
    this.handleWarningChange = this.handleWarningChange.bind(this);
  }

  handleWarningChange(active) {
    this.setState({ warningActive: active });
  }

  render() {
    let userHTML = '';
    let statusHTML = '';
    let functionHTML = '';
    let logoutHTML = '';
    let showhideReceipt = '';

    if (this.props.user !== undefined) {
      if (this.props.user.username !== undefined) {

        userHTML = (
          <div className="titlebar-info">
            <i className="user icon">&nbsp;</i>
            {this.props.user.username}
          </div>
        )

        statusHTML = (
          <TitleBarButton
            text={this.props.getTranslation(resource.STATUS)}
            icon="print icon"
            type={general.TITLEBAR_STATUS}
            onWarningChange={this.handleWarningChange}
            warningActive={this.state.warningActive}
          />
        )

        functionHTML = (
          <TitleBarButton
            text={this.props.getTranslation(resource.FUNCTIONS)}
            icon="settings icon"
            type={general.TITLEBAR_FUNCTION}
          />
        )
        logoutHTML = (<Logout />)

        showhideReceipt = (
          <div className="titlebar-showhidereceipt">
            <TitleBarButton
              text=""
              icon="content icon"
              type={general.TITLEBAR_SHOWHIDERECEIPT}
            />
          </div>
        )
      }
    }

    var divStyle = (this.props.tempRights > 0 || this.state.warningActive)
      ? { backgroundColor: 'darkorange' }
      : null;

    return (
      <div id="titlebar" style={divStyle}>
        <Logo />
        {showhideReceipt}
        <div className="titlebar-buttoncontainer" >
          {statusHTML}
          {functionHTML}
        </div>
        <div className="titlebar-right">
          <div className="titlebar-datetime">
            <DateTime />
          </div>
          {userHTML}
        </div>
        {logoutHTML}
      </div>)
  }
}

TitleBar.propTypes = {
  user: PropTypes.object,
  tempRights: PropTypes.number
}

function mapStateToProps(state) {
  return {
    user: state.loginState.loggedin,
    tempRights: state.generalState.tempRights
  }
}

export default connect(mapStateToProps, { getTranslation })(TitleBar)



// WEBPACK FOOTER //
// src/components/TitleBar.jsx